import { useTranslation } from "react-i18next";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { LANGS, setLanguage } from "@/i18n";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Globe } from "lucide-react";

export function LanguageSwitcher({ dark = false }) {
  const { i18n } = useTranslation();
  const { user, refreshUser } = useAuth();

  const change = async (code) => {
    setLanguage(code);
    if (user) {
      try {
        await api.put("/profile", { language: code });
        refreshUser?.();
      } catch (e) {
        console.warn("language preference save failed", e);
      }
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className={dark ? "text-white hover:bg-slate-800" : "text-slate-600 hover:bg-slate-100"}
          title="Language"
          data-testid="language-switcher"
        >
          <Globe className="h-5 w-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44">
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => change(l.code)}
            className={i18n.language === l.code ? "bg-slate-100 font-semibold" : ""}
            data-testid={`lang-option-${l.code}`}
          >
            {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
